
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessageLines } from '@fortawesome/pro-regular-svg-icons/faMessageLines';
import { Button } from '../Button/Button';
import { UnreadCountBubble } from '../UnreadCountBubble';

export interface Props {
  unreadMessagesCount: number;
  handleClick(): void;
}

export const Messages = ({ unreadMessagesCount, handleClick }: Props): React.JSX.Element => (
  <div className='inline-block relative'>
    <Button
      aria-label='Messages Button'
      className='relative align-middle ml-1 lg:ml-2 hover:opacity-80 hover:text-neutral-600 rounded-full bg-gray-300 w-9 h-9'
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={faMessageLines} className='h-3.5 mt-1' />
      {!!unreadMessagesCount && (
        <UnreadCountBubble
          unreadCount={unreadMessagesCount}
        />
      )}
    </Button>
  </div>
);
